import { useAvailableVehicleList } from '@/hooks/vehicle-listings/use-vehicle-list';
import { useMemo } from 'react';

export type AvailableVehicle = {
  vin: string;
  year: number;
  make: string;
  model: string;
  trim: string;
  purchase_status: string;
  mileage: number;
};

const useAvailableVehicles = (query: string | null) => {
  const vehicles = useAvailableVehicleList();

  const filteredVehicles = useMemo(() => {
    return vehicles.filter(
      (listing) =>
        listing.vehicle?.vin
          ?.toLowerCase()
          .includes(query?.toLowerCase() ?? '') ||
        listing.YMMT.toLowerCase().includes(query?.toLowerCase() ?? '') ||
        listing.vehicle?.model
          .toLowerCase()
          .includes(query?.toLowerCase() ?? '') ||
        listing.vehicle?.year.toString().includes(query?.toLowerCase() ?? '') ||
        listing.vehicle?.make
          .toLowerCase()
          .includes(query?.toLowerCase() ?? ''),
    );
  }, [query, vehicles]);

  return { vehicles: filteredVehicles };
};

export default useAvailableVehicles;
